import React, { useEffect, useState } from 'react'
import { Card, CardBody, Col, Container, Form, Row } from 'reactstrap'
import { ISeoModel } from 'models/Seo.Model';
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { SubmitHandler, useForm } from 'react-hook-form';
import { isRider } from '../../helpers/TokenHelper';
import CommonService from 'services/CommonService';
import { useFormik } from 'formik';
import * as Yup from "yup";
import { CustomTextArea } from 'components/shared/CustomTextArea';
import { CustomButton } from 'components/shared/CustomButton';
import { Toaster_ENUM } from 'components/constants/dsmConstants';
import { CustomTextBox } from 'components/shared/CustomTextBox';
import { CustomToaster } from 'components/shared/CustomToaster';
import CustomLoader from 'components/Common/CustomLoader';

function SEO() {
    const { pageId } = useParams<any>();
    const navigate = useNavigate();
    const pageName = window.location.search.replace("?", "");

    const [seo, setSeo] = useState<ISeoModel>({} as ISeoModel);
    const [SeoList, setSeoList] = useState<Array<ISeoModel>>([]);
    const isAddMode = !pageId;
    const [toast, SetToast] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [showLoading, setShowLoading] = useState(true);


    const { register, handleSubmit, clearErrors, formState: { errors }, reset } = useForm<ISeoModel>();
    const riderlogin: boolean = isRider() ?? false;

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            id: 0,
            created: undefined,
            modified: undefined,
            PageName: '',
            Title: '',
            Keywords: '',
            OGTitle: '',
            OGType: '',
            OGUrl: '',
            OGImage: '',
            OGDescription: '',
            TwitterCard: '',
            TwitterSite: '',
            TwitterTitle: '',
            TwitterDescription: '',
            TwitterImage: '',
            SeocontentTitle: '',
            SeoContent: '',
            Description: ''
        },
        validationSchema: Yup.object({
            PageName: Yup.string().required("Please Enter Page Name"),
            Title: Yup.string().required("Please Enter Title"),
        }),

        onSubmit(values) {
            isAddMode ? createSeo(values) : editSeo(values);

        },
    })


    // const onSubmit: SubmitHandler<ISeoModel> = (data) => {
    // return isAddMode ? createSeo(data) : editSeo(data);
    // };

    function createSeo(data: ISeoModel) {
        setShowLoading(true);
        CommonService.post('sEO', 'Create', data).then((res: any) => {
            if (res.status === 200) {
                window.location.href = "/seo";
                setShowLoading(false);
                // alert("Created successfully");
            }
        }).catch((e: string) => {
            console.log(e);
        });
    }

    function editSeo(data: ISeoModel) {
        setShowLoading(true);
        CommonService.post('sEO', 'Edit', data).then((res: any) => {
            if (res.status === 200) {
                // window.location.href = "/seo";
                setIsEdit(true)
                SetToast(true);
                setShowLoading(false);
                // alert("Successfully Update");
            }
        }).catch((e: string) => {
            console.log(e);
        });
    }

    const Cancel = () => {
        window.location.href = "/seo";
    }


    useEffect(() => {
        const GetSeoDetail = (id: any) => {
            setShowLoading(true)
            if (!isAddMode) {
                CommonService.getWithSingleEntity('sEO', 'Edit', id).then(user => {
                    formik.setValues(user.data)
                    setSeo(user.data);
                    setShowLoading(false)
                });
            }
        }
        GetSeoDetail(pageId);
    }, [pageId, isAddMode]);

    return (
        <React.Fragment>
            <div className="page-content">
                <CustomLoader isOpen={showLoading} />
                <Container fluid>
                    <div>
                        <h5 className="d-flex mb-3 fw-semibold text-dofy dofy-admin-font-md" style={{ whiteSpace: "nowrap" }}>SEO Edit</h5>
                    </div>
                    <Card style={{ padding: '20px' }}>
                        <div>
                            <span className={`badge rounded-pill badge-soft-info fw-bolder px-3 pt-2 my-2`}>
                                <h5 >{`Manage SEO for ${pageName} Page`}</h5>
                            </span>
                            <Form className="form-horizontal"
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    formik.handleSubmit();
                                    return false;
                                }}
                            >
                                <Row>
                                    <Col xl={6}>
                                        <CustomTextBox
                                            name="PageName"
                                            label="Page Name"
                                            id={"PageName"}
                                            value={formik.values.PageName}
                                            onBlur={formik.handleBlur}
                                            invalid={formik.touched.PageName && formik.errors.PageName ? true : false}
                                            error={formik.errors.PageName}
                                            onChange={formik.handleChange}
                                            // placeholder={""}
                                            isMandatory={true}
                                            disabled={true} />
                                    </Col>
                                    <Col xl={6}>
                                        <CustomTextBox
                                            name="Title"
                                            label="Title"
                                            id={"Title"}
                                            value={formik.values.Title}
                                            onBlur={formik.handleBlur}
                                            invalid={formik.touched.Title && formik.errors.Title ? true : false}
                                            error={formik.errors.Title}
                                            onChange={formik.handleChange}
                                            // placeholder={""}
                                            isMandatory={true} />
                                    </Col>
                                    <Col xl={6}>
                                        <CustomTextArea
                                            name="Keywords"
                                            label="Keywords"
                                            id={"Title"}
                                            value={formik.values.Keywords}
                                            onBlur={formik.handleBlur}
                                            invalid={formik.touched.Keywords && formik.errors.Keywords ? true : false}
                                            error={formik.errors.Keywords}
                                            onChange={formik.handleChange}
                                            // placeholder={""}
                                            isMandatory={false} />
                                    </Col>
                                    <Col xl={6}>
                                        <CustomTextArea
                                            name="Description"
                                            label="Description"
                                            id={"Description"}
                                            value={formik.values.Description}
                                            onBlur={formik.handleBlur}
                                            invalid={formik.touched.Description && formik.errors.Description ? true : false}
                                            error={formik.errors.Description}
                                            onChange={formik.handleChange}
                                            // placeholder={""}
                                            isMandatory={false} />
                                    </Col>
                                </Row>
                                <Row className='my-2'>
                                    <Col xl={12}>
                                        <CustomTextBox
                                            name="SeocontentTitle"
                                            label="SeocontentTitle"
                                            id={"SeocontentTitle"}
                                            value={formik.values.SeocontentTitle}
                                            onBlur={formik.handleBlur}
                                            invalid={formik.touched.SeocontentTitle && formik.errors.SeocontentTitle ? true : false}
                                            error={formik.errors.SeocontentTitle}
                                            onChange={formik.handleChange}
                                            // placeholder={""}
                                            isMandatory={false} />
                                    </Col>
                                    <Col xl={12}>
                                        <CustomTextArea
                                            name="SeoContent"
                                            label="SeoContent"
                                            id={"SeoContent"}
                                            value={formik.values.SeoContent}
                                            onBlur={formik.handleBlur}
                                            invalid={formik.touched.SeoContent && formik.errors.SeoContent ? true : false}
                                            error={formik.errors.SeoContent}
                                            onChange={formik.handleChange}
                                            // placeholder={""}
                                            isMandatory={false} />
                                    </Col>
                                </Row>
                                <Row className='mb-2 '>
                                    <Col xl={6}>
                                        <CustomTextBox
                                            name="OGType"
                                            label="OGType"
                                            id={"OGType"}
                                            value={formik.values.OGType}
                                            onBlur={formik.handleBlur}
                                            invalid={formik.touched.OGType && formik.errors.OGType ? true : false}
                                            error={formik.errors.OGType}
                                            onChange={formik.handleChange}
                                            // placeholder={""}
                                            isMandatory={false} />
                                    </Col>
                                    <Col xl={6}>
                                        <CustomTextBox
                                            name="OGUrl"
                                            label="OGUrl"
                                            id={"OGUrl"}
                                            value={formik.values.OGUrl}
                                            onBlur={formik.handleBlur}
                                            invalid={formik.touched.OGUrl && formik.errors.OGUrl ? true : false}
                                            error={formik.errors.OGUrl}
                                            onChange={formik.handleChange}
                                            // placeholder={""}
                                            isMandatory={false} />
                                    </Col>
                                    <Col xl={6}>
                                        <CustomTextBox
                                            name="OGTitle"
                                            label="OGTitle"
                                            id={"OGTitle"}
                                            value={formik.values.OGTitle}
                                            onBlur={formik.handleBlur}
                                            invalid={formik.touched.OGTitle && formik.errors.OGTitle ? true : false}
                                            error={formik.errors.OGTitle}
                                            onChange={formik.handleChange}
                                            // placeholder={""}
                                            isMandatory={false} />
                                    </Col>
                                    <Col xl={6}>
                                        <CustomTextBox
                                            name="OGImage"
                                            label="OGImage"
                                            id={"OGImage"}
                                            value={formik.values.OGImage}
                                            onBlur={formik.handleBlur}
                                            invalid={formik.touched.OGImage && formik.errors.OGImage ? true : false}
                                            error={formik.errors.OGImage}
                                            onChange={formik.handleChange}
                                            // placeholder={""}
                                            isMandatory={false} />
                                    </Col>
                                    <Col xl={12}>
                                        <CustomTextArea
                                            name="OGDescription"
                                            label="OGDescription"
                                            id={"OGDescription"}
                                            value={formik.values.OGDescription}
                                            onBlur={formik.handleBlur}
                                            invalid={formik.touched.OGDescription && formik.errors.OGDescription ? true : false}
                                            error={formik.errors.OGDescription}
                                            onChange={formik.handleChange}
                                            // placeholder={""}
                                            isMandatory={false} />
                                    </Col>
                                </Row>
                                <Row className='mb-2 '>
                                    <Col xl={6}>
                                        <CustomTextBox
                                            name="TwitterCard"
                                            label="TwitterCard"
                                            id={"TwitterCard"}
                                            value={formik.values.TwitterCard}
                                            onBlur={formik.handleBlur}
                                            invalid={formik.touched.TwitterCard && formik.errors.TwitterCard ? true : false}
                                            error={formik.errors.TwitterCard}
                                            onChange={formik.handleChange}
                                            // placeholder={""}
                                            isMandatory={false} />
                                    </Col>
                                    <Col xl={6}>
                                        <CustomTextBox
                                            name="TwitterSite"
                                            label="TwitterSite"
                                            id={"TwitterSite"}
                                            value={formik.values.TwitterSite}
                                            onBlur={formik.handleBlur}
                                            invalid={formik.touched.TwitterSite && formik.errors.TwitterSite ? true : false}
                                            error={formik.errors.TwitterSite}
                                            onChange={formik.handleChange}
                                            // placeholder={""}
                                            isMandatory={false} />
                                    </Col>
                                    <Col xl={6}>
                                        <CustomTextBox
                                            name="TwitterTitle"
                                            label="TwitterTitle"
                                            id={"TwitterTitle"}
                                            value={formik.values.TwitterTitle}
                                            onBlur={formik.handleBlur}
                                            invalid={formik.touched.TwitterTitle && formik.errors.TwitterTitle ? true : false}
                                            error={formik.errors.TwitterTitle}
                                            onChange={formik.handleChange}
                                            // placeholder={""}
                                            isMandatory={false} />
                                    </Col>
                                    <Col xl={6}>
                                        <CustomTextBox
                                            name="TwitterImage"
                                            label="TwitterImage"
                                            id={"TwitterImage"}
                                            value={formik.values.TwitterImage}
                                            onBlur={formik.handleBlur}
                                            invalid={formik.touched.TwitterImage && formik.errors.TwitterImage ? true : false}
                                            error={formik.errors.TwitterImage}
                                            onChange={formik.handleChange}
                                            // placeholder={""}
                                            isMandatory={false} />
                                    </Col>
                                    <Col xl={12}>
                                        <CustomTextArea
                                            name="TwitterDescription"
                                            label="TwitterDescription"
                                            id={"TwitterDescription"}
                                            value={formik.values.TwitterDescription}
                                            onBlur={formik.handleBlur}
                                            invalid={formik.touched.TwitterDescription && formik.errors.TwitterDescription ? true : false}
                                            error={formik.errors.TwitterDescription}
                                            onChange={formik.handleChange}
                                            // placeholder={""}
                                            isMandatory={false} />
                                    </Col>
                                    <Col lg={12} className='d-flex justify-content-end mt-4'>
                                        <CustomButton
                                            type="button"
                                            btnClassName="ms-2 btn-soft-secondary w-md"
                                            iconClasssName="mdi mdi-close"
                                            name=""
                                            onClick={() => navigate('/seo')}
                                        />
                                        {/* <CustomButton
                                        type="reset"
                                        btnClassName="ms-2 btn-soft-primary w-md"
                                        iconClasssName=""
                                        name="Reset"
                                    /> */}
                                        <CustomButton
                                            type={"submit"}
                                            btnClassName={"ms-2 btn-success w-md"}
                                            iconClasssName=""
                                            name={"Update SEO"}
                                        />
                                    </Col>
                                </Row>
                            </Form>
                        </div>
                        {toast && isEdit ? (
                            <CustomToaster
                                message={Toaster_ENUM.update.text}
                                color={"text-success"}
                                toast={toast}
                                setToast={SetToast}
                                path={'/seo'}
                            // path={!isModelOpen ? "/lead" : isLeadKanban ? "/lead-kanban-view" : `/customer/view/${id}`}
                            />
                        ) : <></>
                        }
                    </Card>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default SEO


